<template>
  <div class="sub">
    <nav-bar
      :title="subTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
      @click-right="onCLickRight"
    >
     <!-- <icon class="active-nav" slot="right" name="wap-nav" size="0.2rem" />-->
    </nav-bar>
    <router-view class="sub-router" />
    <popup v-model="popupShow" closeable position="bottom" :style="{ height: '100%' }" class="sub-popup">
      <ul class="ul-tabs">
        <li v-for="(item, index) in tabList" :key="index" @click="navTabsFn(item)">{{item.name}}</li>
      </ul>
    </popup>
  </div>
</template>

<script>
import { NavBar, Popup } from "vant";
import { mapState } from "vuex";
export default {
  name: "subpage",
  components: {
    NavBar,
    //Icon,
    Popup
  },
  computed: {
    ...mapState({
      route: state => state.route,
      subTitle: state => state.subTitle
    })
  },
  data() {
    return {
      popupShow: false,
      tabList: [
        {
          name: "职位"
        },
        {
          name: "简历"
        },
        {
          to: "/home",
          name: "双选会"
        },
        {
          name: "消息"
        },
        {
          name: "我的"
        }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    onClickLeft() {
      this.$router.go(-1);
    },
    onCLickRight() {
      this.popupShow = true
    },
    navTabsFn(item){
      const {
        name, to
      } = item

      this.popupShow = false

      if (to){
        this.$router.push({path: to})
        return
      }

      let that = this

      that.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner"
      });

      that.$util
        .goToWxProgram("/pages/seeker/tabs/main?title=" + name, "reLaunch")
        .then((state, res) => {
          if (state === "fail") {
            const { errMsg } = res || {};

            this.$dialog
              .alert({
                title: "请在快招聘小程序中打开,subtabs",
                message: errMsg || ""
              })
              .then(() => {});
          }
        });
    }
  }
};
</script>

<style lang="scss">
.van-nav-bar--fixed {
  z-index: 20 !important;
}

.sub-popup{
  $mainC: #3796EE;

  background-color: $mainC;
  color: #fff;
  background-image: url('/img/weyon.png');
  background-position: center 185%;
  background-repeat: no-repeat;

  .van-icon{
    color: #fff;
    font-size: 0.2rem;
  }

  .ul-tabs{
    padding-top: 25%;

    >li{
      font-size: 0.16rem;
      line-height: 0.22rem;
      padding: 0.125rem 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.sub {
  > .sub-router {
    height: 100%;
    width: 100%;
    padding-top: 46px;
    overflow: auto;
    @include box-sizing(border-box);
  }
}
</style>
